import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

export const apiUrlInterceptor: HttpInterceptorFn = (req, next) => {
    const translocoService = inject(TranslocoService);

    // Check if we have a stored language preference
    const storedLang = localStorage.getItem('userLanguage');

    // Use the stored language or fallback to the active language or default
    const lang = storedLang || translocoService.getActiveLang() || 'fr';

    // Clone the request with the language header
    const clonedReq = req.clone({
        setHeaders: {
            'Accept-Language': lang
        },
    });

    return next(clonedReq);
};